import React, { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext.js';

function Projects() {
  const { language, translations } = useContext(LanguageContext);

  return (
    <div className="page projects">
      <h1 className='header'>{translations[language].pages.projects.h1}</h1>
      <ul>
        <li className='paragraph'>{translations[language].pages.projects.p1}</li>
      </ul>
    </div>
  );
}

export default Projects;